$(document).ready(function () {
  // Function to handle adding/removing badge class
  function updateBadgeClass() {
    $(".field-check.test.multi.active").each(function () {
      var list = $(this).closest("li");
      list.find(".pack-info").addClass("badge");
    });

    $(".field-check.test.single.active").each(function () {
      var list = $(this).closest("li");
      list.find(".pack-info").removeClass("badge");
    });
  }

  // Run on initial page load
  updateBadgeClass();

  // Monitor URL changes
  let lastUrl = window.location.href;
  setInterval(function () {
    const currentUrl = window.location.href;
    if (lastUrl !== currentUrl) {
      lastUrl = currentUrl;
      // Trigger logic when URL changes
      updateBadgeClass();
    }
  }, 500); // Check every 500ms for URL changes

  // Handle clicks on elements with 'field-check test' class dynamically
  $(document).on("click", ".field-check.test", function () {
    var form = $(this).closest("form");
    var list = $(this).closest("li");
    var clickedButton = $(this);

    if (clickedButton.hasClass("single")) {
      form.find(".field-check").removeClass("active");
      clickedButton.addClass("active");
      form.find(".single-price").addClass("active");
      form.find(".pack-price").removeClass("active");
      list.find(".pack-info").removeClass("badge");
    }

    if (clickedButton.hasClass("multi")) {
      form.find(".field-check").removeClass("active");
      clickedButton.addClass("active");
      form.find(".single-price").removeClass("active");
      form.find(".pack-price").addClass("active");
      list.find(".pack-info").addClass("badge");
    }

    var variantId = clickedButton.find(".unitPallet").data("variant-id");
    form.find("input.variantId").val(variantId);
  });
});

// Dynamically handle clicks on elements within '.pack_discount'
$(document).on("click", ".pack_discount .listening", function () {
  setTimeout(function () {
    location.reload();
  }, 1000); // Delays the reload by 1 second
});
